import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Wrapper, Icon, Content, TopicName, Info, Collapse } from './styled';
import SvgIcon from '../../svg-icon/svg-icon';
import {
  ExpandButton,
  StandardDropdown
} from '../../../helpers/icon-dictionary';
import ContextModal, { ContextModalWidth } from '../../context-modal';
import TopicInfo from '../../topic-info';
import { getContextCoords } from '../../../helpers/utils';
import OutsideClickHandler from '../../../helpers/hoc/close/outside-click-handler';
import {
  DISPLAY_MODAL_INFORMATION,
  HIDE_STANDARD
} from '../../../containers/course-assign/course-assign-types';

const TopicCollapsed = ({ handleOnExpand, topicName, id }) => {
  const dispatch = useDispatch();
  const myRef = useRef(null);

  const [showInfo, setInfo] = useState(false);
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);
  const [positionArrow, setPositionArrow] = useState(0);
  const [positionXCallout, setPositionXCallout] = useState(0);
  const [positionYCallout, setPositionYCallout] = useState(0);
  const [positionArrowCallout, setPositionArrowCallout] = useState(0);
  const [callOut, setCallOut] = useState(false);
  const standardRef = useRef(null);
  const [contextTheme, setContextTheme] = useState(null);

  const showDropdown = () => {
    const { posX, posY, posArrow } = getContextCoords(
      myRef.current.getBoundingClientRect(),
      ContextModalWidth
    );
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setCallOut(false);
    setInfo(false);
  };

  const hideStandardBlock = () => {
    dispatch({
      type: HIDE_STANDARD,
      id
    });
    dispatch({
      type: DISPLAY_MODAL_INFORMATION,
      key: -1
    });
  };

  const showCallOut = () => {
    const { posX, posY, posArrow } = getContextCoords(
      standardRef.current.getBoundingClientRect(),
      ContextModalWidth
    );
    setPositionYCallout(posY);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOut(true);
  };

  const hideCallOut = () => {
    setCallOut(false);
  };

  return (
    <Wrapper>
      <Collapse
        role="button"
        tabIndex="0"
        onClick={() => handleOnExpand(false)}
      >
        <SvgIcon icon={ExpandButton} />
      </Collapse>
      <Info
        role="button"
        onClick={showDropdown}
        ref={standardRef}
        onMouseEnter={showCallOut}
        onMouseLeave={hideCallOut}
      >
        <Content>
          <TopicName>{topicName}</TopicName>
        </Content>
        <Icon ref={myRef}>
          <SvgIcon icon={StandardDropdown} />
        </Icon>
      </Info>
      <OutsideClickHandler
        callback={() => setInfo(false)}
        forButton={`showContextModal_${id}`}
      >
        <ContextModal
          show={showInfo}
          positionArrow={positionArrow}
          positionX={positionX}
          positionY={positionY}
        >
          <TopicInfo
            standardName={topicName}
            hideStrand={hideStandardBlock}
            displayHideOption
          />
        </ContextModal>
        <ContextModal
          show={callOut}
          positionArrow={positionArrowCallout}
          positionX={positionXCallout}
          positionY={positionYCallout}
          contextTheme={contextTheme}
          name={topicName}
        />
      </OutsideClickHandler>
    </Wrapper>
  );
};

TopicCollapsed.propTypes = {
  handleOnExpand: PropTypes.func.isRequired,
  topicName: PropTypes.string,
  id: PropTypes.number
};

TopicCollapsed.defaultProps = {
  handleOnExpand: () => {},
  topicName: ''
};

export default TopicCollapsed;



// WEBPACK FOOTER //
// ./components/topic/collapsed/index.js